// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './generated/routes/_app'
import { Route as AppIndexRouteImport } from './generated/routes/_app/index'
import { Route as AppSubmissionsRouteImport } from './generated/routes/_app/submissions'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSubmissionsRoute = AppSubmissionsRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppSubmissionsRoute: AppSubmissionsRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)